import { render, staticRenderFns } from "./ConsultationsControl.vue?vue&type=template&id=c1ee0d56&scoped=true"
import script from "./ConsultationsControl.vue?vue&type=script&lang=js"
export * from "./ConsultationsControl.vue?vue&type=script&lang=js"
import style0 from "./ConsultationsControl.vue?vue&type=style&index=0&id=c1ee0d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ee0d56",
  null
  
)

export default component.exports